/* eslint-disable */
<template>
  <Modal v-if="activeCustomizeIndex !== null" :visible="visible ?? false" :footer="null" :destroyOnClose="true"
    wrap-class-name="empty-modal" width="1000px" @ok="hide" @cancel="hide">
    <div>
      <iframe
        :src="`${apiUrl}/custom-email-recommendation/view/program?commute_recommendation_id=${customizeEmailId}&token=${token}`"
        frameborder="0" width="100%" style="min-height: 75vh" title="preview email"></iframe>
    </div>
  </Modal>
  <div class="rounded-lg p-3 lg:p-5 bg-bg border border-bg-dark border-solid mt-5">
    <div class="flex justify-between">
      <Checkbox v-model:checked="checked" :disabled="isOngoing && hasStarted">
        <h3 class="text-xl text-primary-dark">Individual Commute Recommendations</h3>
      </Checkbox>
      <SaveBtn :disabled="!isShowCheckedSaved" :loading="isFetching" @click="handleSave" class="mt-0" />
    </div>
    <div v-if="rewardData && checked">
      <div class="text-end">
        <span @keyup="
          () => {
            console.log('Add Weekly Credit');
          }
        " @click="addWeeklyCredit" style="
            font-size: 12px;
            font-weight: bolder;
            display: inline-block;
            padding: 3px 6px 3px 6px;
            border-radius: 10px;
            background-color: #278c64;
            color: white;
            cursor: pointer;
          ">+</span>
      </div>
      <div class="mt-6" v-for="(weekly_credit_structure, index) in commute_recommendations_structures" :key="index">
        <div class="text-end">
          <span v-if="index == lengthOfWeeklyStructure - 1 && index != 0" @keyup="
            () => {
              console.log('Remove Weekly Credit');
            }
          " @click="removeWeeklyCredit" style="
              font-size: 12px;
              font-weight: bolder;
              display: inline-block;
              padding: 3px 6px 3px 6px;
              border-radius: 10px;
              background-color: #c7cbcd;
              color: black;
              cursor: pointer;
            ">-</span>
        </div>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6">
          <div class="inputs flex flex-col gap-1 items-start">
            <div class="flex flex-row items-center gap-2">
              <span class="font-bold">Budget limit</span>
              <InputNumber :disabled="isOngoing && hasStarted" class="w-20"
                :value="weekly_credit_structure.budget_limit" @change="(val) => setVal(+val, 'budget_limit', index)"
                :min="0" prefix="$" :step="0.5" />
              <span class="font-bold">for all users</span>
            </div>
            <div class="flex flex-row items-center gap-2">
              <span class="font-bold">Incentives</span>
              <InputNumber :disabled="isOngoing && hasStarted" class="w-20"
                :value="weekly_credit_structure.incentive_per_trip"
                @change="(val) => setVal(+val, 'incentive_per_trip', index)" :min="0" prefix="$" :step="0.5" />
              <span class="font-bold">per trip</span>
            </div>
            <div class="flex flex-row items-center gap-2">
              <span class="font-bold">Limit on number of incentivized trips</span>
              <InputNumber :disabled="isOngoing && hasStarted" class="w-20"
                :value="weekly_credit_structure.limit_of_incentivized_trips"
                @change="(val) => setVal(+val, 'limit_of_incentivized_trips', index)" :min="0" :step="2" />
              <span class="font-bold">trips per user</span>
            </div>
          </div>

          <div class="flex flex-col justify-center">
            <div class="text-center flex items-center justify-center gap-2">
              <span class="font-bold">Program timeline</span>
              <div class="text-center flex flex-col flex-wrap justify-center items-center gap-2">
                <div class="w-40">
                  <CustumCalender name="start_date" defaultFormate="MMM, D, YYYY" placeholder="Start Date"
                    :default-data="getDefaultDate(weekly_credit_structure?.start_date ?? null)" :rules="{
                      required: false,
                    }" @setInput="(data) => setInputStartDate(data, index)" />
                </div>
              </div>
              <span class="font-bold">to</span>
              <div class="text-center flex flex-col flex-wrap justify-center items-center gap-2">
                <div class="w-40">
                  <CustumCalender name="end_date" defaultFormate="MMM, D, YYYY"
                    :default-data="getDefaultDate(weekly_credit_structure?.end_date ?? null)" placeholder="End Date"
                    :rules="{
                      required: false,
                    }" @setInput="(data) => setInputEndDate(data, index)" />
                </div>
              </div>
            </div>
            <div class="text-center flex items-center justify-center gap-2">
              <span class="font-bold">${{ weekly_credit_structure?.budget_consumed ?? 0 }} issued till now</span>
            </div>
          </div>
        </div>
        <Divider />
        <div class="section">
          <div class="section-title">Selected users</div>
          <div class="chips-container" v-if="commute_recommendations_structures[index]['selected_users'].length">
            <div class="chip font-bold flex items-center flex-row" v-for="(user, userIndex) in commute_recommendations_structures[index][
              'selected_users'
            ]" v-bind:key="userIndex">
              <div class="flex flex-col">
                <span>
                  <p>{{ user.name }}</p>
                </span><small>{{ user.description }}</small>
              </div>
              <button class="close-btn" @click="() => removeUser(index, userIndex)">×</button>
            </div>
          </div>
          <div v-else>
            <p>No selected users</p>
          </div>
        </div>
        <div class="grid grid-cols-1 gap-4 lg:gap-6">
          <div class="inputs flex flex-col gap-1 items-start">
            <div class="flex flex-row items-center gap-2">
              <span class="font-bold">Users with Single Occupant Vehicle trips in the past 2 months and feasible transit
                option(s)</span>
              <CustumSelect name="transit" placeholder="Select user" class="min-w-[250px]" :data="users_with_single_occupant_vehicle_trips_in_the_past_2_months_and_feasible_transit_option
                " :rules="{
                  required: false,
                }" @setInput="(data) => setInput(data, index)" />
            </div>
            <div class="flex flex-row items-center gap-2">
              <span class="font-bold">Users with Single Occupant Vehicle trips in the past 2 months and feasible biking
                or walking option(s)</span>
              <CustumSelect name="biking_walking" placeholder="Select user" class="min-w-[250px]" :data="users_with_single_occupant_vehicle_trips_in_the_past_2_months_and_feasible_biking_or_walking_option
                " :rules="{
                  required: false,
                }" @setInput="(data) => setInput(data, index)" />
            </div>
            <div class="flex flex-row items-center gap-2">
              <span class="font-bold">Inactive users with single occupant vehicle trips in the past 2 months and have
                access to transit, biking, or walking options</span>
              <CustumSelect name="inactive" placeholder="Select user" class="min-w-[250px]"
                :data="inactive_users_with_single_occupant_vehicle_trips" :rules="{
                  required: false,
                }" @setInput="(data) => setInput(data, index)" />
            </div>
          </div>
        </div>
        <Divider />
        <div class="section">
          <div class="section-title">Communication</div>

          <Tabs class="w-full">
            <TabPane key="1" tab="Email configuration">
              <div class="flex items-center gap-2">
                <Checkbox v-model:checked="commute_recommendations_structures[index]['send_email']"
                  :disabled="isOngoing && hasStarted">
                  <h3>Send email for the program participants on</h3>
                </Checkbox>
                <div class="chips-container">
                  <CustumSelect name="email_day" placeholder="Day" class="min-w-[250px]"
                    :default-data="weekly_credit_structure?.email_day ?? null" :data="days" :rules="{
                      required: false,
                    }" @setInput="(data) => setInput(data, index)" />
                </div>
                <h3>at</h3>
                <TimePicker format="HH:mm" class="" v-model:value="commute_recommendations_structures[index]['time']"
                  value-format="HH:mm" />
              </div>
              <CustumInput style="width: 100%" name="title" :defaultData="weekly_credit_structure.title ?? null"
                :defaultError="null" label="Title" placeholder="Title"
                @setInput="(val) => setVal(val.title?.value ?? null, 'title', index)" />
              <div class="flex justify-center mt-3 gap-2">
                <Button v-if="!disabled" type="primary" :disabled="disabled || loading" :loading="loading"
                  class="!h-auto btn-gradient" @click="() => customize(index)">
                  <div class="flex items-center gap-1 px-4 md:px-6">
                    <PhEnvelope size="18" weight="bold" />Customize
                  </div>
                </Button>
                <Button v-if="!disabled && weekly_credit_structure?._id" type="primary"
                  :disabled="sending_sample || loading" :loading="loading" class="!h-auto btn-gradient"
                  @click="() => send_sample(weekly_credit_structure?._id)">
                  <div class="flex items-center gap-1 px-4 md:px-6">
                    <PhPaperPlaneRight size="18" weight="bold" />Send Sample
                  </div>
                </Button>
              </div>
            </TabPane>

            <tab-pane key="2" tab="Sent emails">
              <CommuteRecommendationsEmails v-if="weekly_credit_structure['_id'] ?? null"
                :commute_recommendation="weekly_credit_structure['_id']" />
            </tab-pane>
          </Tabs>

        </div>
        <Divider />
      </div>

      <div class="w-full flex justify-center md:justify-end">
        <SaveBtn :disabled="!isValueChanged" :loading="isFetching" @click="handleSave" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {
  Checkbox,
  InputNumber,
  Radio,
  RadioGroup,
  Spin,
  Divider,
  message,
  Row,
  Col,
  DatePicker,
  TimePicker,
  Button,
  Modal,
  TabPane,
  Tabs,
} from 'ant-design-vue';
import { REWARD } from '../../../../store/types';
import SaveBtn from '../shared/SaveBtn.vue';
import CustumCalender from '@/components/shared/form/CustumCalender.vue';
import CustumSelect from '@/components/shared/form/CustumSelect.vue';
import CustumInput from '@/components/shared/form/CustumInput.vue';
import dayjs from 'dayjs';
import { PhEnvelope, PhPaperPlaneRight } from 'phosphor-vue';
import { getToken } from '@/services/jwt.service';
import CommuteRecommendationsEmails from './CommuteRecommendationsEmails.vue';
import membersApi from '@/services/apis/members.api';

export default {
  components: {
    Checkbox,
    InputNumber,
    Radio,
    RadioGroup,
    Spin,
    SaveBtn,
    Divider,
    CustumCalender,
    CustumSelect,
    Row,
    Col,
    DatePicker,
    TimePicker,
    CustumInput,
    Button,
    PhEnvelope,
    Modal,
    TabPane,
    Tabs,
    CommuteRecommendationsEmails,
    PhPaperPlaneRight
  },
  props: {
    isOngoing: {
      type: Boolean,
      default: false,
    },
    hasStarted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: false,
      visible: false,
      sending_sample: false,
      radioValue: 1,
      token: null,
      activeCustomizeIndex: null,
      days: [
        { id: 2, name: 'Monday' },
        { id: 3, name: 'Tuesday' },
        { id: 4, name: 'Wednesday' },
        { id: 5, name: 'Thursday' },
        { id: 6, name: 'Friday' },
        { id: 7, name: 'Saturday' },
        { id: 1, name: 'Sunday' },
      ],
      default_commute_recommendations_DTO: {
        _id: null,
        start_date: null,
        end_date: null,
        budget_limit: 50,
        budget_consumed: 0,
        incentive_per_trip: 2.5,
        limit_of_incentivized_trips: 4,
        users_with_single_occupant_vehicle_trips_in_the_past_2_months_and_feasible_transit_option:
          [],
        users_with_single_occupant_vehicle_trips_in_the_past_2_months_and_feasible_biking_or_walking_option:
          [],
        inactive_users_with_single_occupant_vehicle_trips: [],
        selected_users: [],
        send_email: false,
        email_day: null,
        title: null,
        time: "09:00",
      },
      commute_recommendations_structures: [
        {
          _id: null,
          start_date: null,
          end_date: null,
          budget_limit: 50,
          budget_consumed: 0,
          incentive_per_trip: 2.5,
          limit_of_incentivized_trips: 4,
          users_with_single_occupant_vehicle_trips_in_the_past_2_months_and_feasible_transit_option:
            [],
          users_with_single_occupant_vehicle_trips_in_the_past_2_months_and_feasible_biking_or_walking_option:
            [],
          inactive_users_with_single_occupant_vehicle_trips: [],
          selected_users: [],
          send_email: false,
          email_day: null,
          title: null,
          time: "09:00",
        },
      ],
    };
  },
  created() {
    this.token = getToken();
    if (this.rewardData) {
      // // console.log("this.rewardData.weekly_credits => ", this.rewardData.weekly_credits);
      // validate config to get away from any errors
      const data = this.rewardData.commute_recommendations
        ? JSON.parse(JSON.stringify(this.rewardData.commute_recommendations))
        : this.commute_recommendations_structures;
      this.commute_recommendations_structures =
        data.length > 0 ? data : this.commute_recommendations_structures;
      this.checked = this.rewardData?.commute_recommendations_enabled ?? false;
    }
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API || 'https://dev.api.commutrics.com/api';
    },
    rewardData() {
      return this.$store.getters.rewardSettingsData;
    },
    usersCategorizedData() {
      return this.$store.getters.usersCategorizedData;
    },
    defaultRewardData() {
      return this.$store.getters.rewardDefaultsData;
    },
    isFetching() {
      return this.$store.state.reward.rewardSettingsQuery?.isFetching;
    },
    signupIncentives() {
      return this.$store.state.reward.signup_incentives;
    },
    isValueChanged() {
      // console.log("are we here ?")
      if (this.checked && this.checked !== this.rewardData.commute_recommendations_enabled)
        return true;
      let isChanged = false;
      let validateIfWeeklyCredits =
        this.rewardData.commute_recommendations ?? this.commute_recommendations_structures;
      if (
        JSON.stringify(validateIfWeeklyCredits) !==
        JSON.stringify(this.commute_recommendations_structures)
      ) {
        isChanged = true;
      }
      return isChanged;
    },
    // checked() {
    //   return this.$store.state.reward.is_signup_incentives_selected;
    // },
    isShowCheckedSaved() {
      return !this.checked && this.checked !== this.rewardData.commute_recommendations_enabled;
    },
    lengthOfWeeklyStructure() {
      return this.commute_recommendations_structures.length;
    },
    users_with_single_occupant_vehicle_trips_in_the_past_2_months_and_feasible_transit_option() {
      return (
        this.usersCategorizedData?.employess_feasible_transit?.map((v) => {
          return { id: v?._id, name: v?.name };
        }) ?? []
      );
    },
    users_with_single_occupant_vehicle_trips_in_the_past_2_months_and_feasible_biking_or_walking_option() {
      return (
        this.usersCategorizedData?.employes_feasible_biking_or_walking?.map((v) => {
          return { id: v?._id, name: v?.name };
        }) ?? []
      );
    },
    inactive_users_with_single_occupant_vehicle_trips() {
      return (
        this.usersCategorizedData?.users_inactive_employees_feasible_biking_or_walking_or_transit?.map(
          (v) => {
            return { id: v?._id, name: v?.name };
          },
        ) ?? []
      );
    },
    customizeEmailId() {
      return this.commute_recommendations_structures[this.activeCustomizeIndex]?._id ?? null;
    },
  },
  methods: {
    hide() {
      this.visible = false;
    },
    getDefaultDate(date) {
      if (!date) return null;
      return dayjs(date?.split('T')[0], 'YYYY-MM-DD').format('MMM, D, YYYY');
    },
    customize(index) {
      this.handleSave();
      this.activeCustomizeIndex = index;
      this.visible = true;
    },
    send_sample(id) {
      this.sending_sample = true;

      membersApi.SendTestEmailPromotion(id).then(() => {
        this.sending_sample = false;

        message.success("A sample e-mail was sent successfully");
      }).catch(() => {
        this.sending_sample = false;

        message.error("There was an error, couldn't send the e-mail");
      });


    },
    handleSave() {
      // console.log("this.commute_recommendations_structures =>",this.commute_recommendations_structures)
      let commute_recommendations_structures = this.commute_recommendations_structures;
      this.$store.dispatch(REWARD.ACTION_UPDATE_REWARD_SYS, {
        commute_recommendations: {
          ...commute_recommendations_structures,
        },
        commute_recommendations_enabled: this.checked,
      });
    },
    removeUser(index1, index2) {
      const user_to_remove =
        this.commute_recommendations_structures[index1].selected_users[index2].id;
      this.commute_recommendations_structures[
        index1
      ].inactive_users_with_single_occupant_vehicle_trips = this.commute_recommendations_structures[
        index1
      ].inactive_users_with_single_occupant_vehicle_trips.filter(
        (v, index3) => v != user_to_remove,
      );
      this.commute_recommendations_structures[
        index1
      ].users_with_single_occupant_vehicle_trips_in_the_past_2_months_and_feasible_biking_or_walking_option =
        this.commute_recommendations_structures[
          index1
        ].users_with_single_occupant_vehicle_trips_in_the_past_2_months_and_feasible_biking_or_walking_option.filter(
          (v, index3) => v != user_to_remove,
        );
      this.commute_recommendations_structures[
        index1
      ].users_with_single_occupant_vehicle_trips_in_the_past_2_months_and_feasible_transit_option =
        this.commute_recommendations_structures[
          index1
        ].users_with_single_occupant_vehicle_trips_in_the_past_2_months_and_feasible_transit_option.filter(
          (v, index3) => v != user_to_remove,
        );
      this.commute_recommendations_structures[index1].selected_users =
        this.commute_recommendations_structures[index1].selected_users.filter(
          (v, index3) => index3 != index2,
        );
    },
    setVal(val, key, index) {
      // console.log("val => ", val)
      let ourObject = {};
      if (key == 'config') {
        ourObject = { ...this.commute_recommendations_structures[index] };
        ourObject.config = {
          number_of_trips: val,
        };
      } else if (key == 'value') {
        ourObject = { ...this.commute_recommendations_structures[index] };
        ourObject['value'] = val;
      } else {
        ourObject = { ...this.commute_recommendations_structures[index] };
        ourObject[key] = val;
      }
      let newArray = [];
      // console.log("ourObject => ",ourObject)
      // console.log("commute_recommendations_structures before map ",this.commute_recommendations_structures)
      this.commute_recommendations_structures.map((item, indexMatch) => {
        let config = {};
        if (!item.config) {
          item.config = { number_of_trips: 3 };
        }

        if (index == indexMatch) {
          newArray.push(ourObject);
        } else {
          newArray.push(item);
        }
      });

      // console.log("newArray =>",newArray)
      this.commute_recommendations_structures = newArray;
      // console.log("newArray this.commute_recommendations_structures=>",this.commute_recommendations_structures)
    },
    setInput(val, index) {
      let selected_users = this.commute_recommendations_structures[index]['selected_users'].map(
        (v) => v?.id,
      );
      if (val.transit && val.transit.value) {
        let key =
          'users_with_single_occupant_vehicle_trips_in_the_past_2_months_and_feasible_transit_option';
        if (!selected_users.includes(val.transit.value)) {
          this.commute_recommendations_structures[index][key].push(val.transit.value);
          this.commute_recommendations_structures[index].selected_users.push({
            id: val.transit.value,
            name: this[key][val.transit.key].name,
            description: 'Recommending transit',
          });
        } else {
          message.error("You've already added this user");
        }
      }
      if (val.biking_walking && val.biking_walking.value) {
        let key =
          'users_with_single_occupant_vehicle_trips_in_the_past_2_months_and_feasible_biking_or_walking_option';
        if (!selected_users.includes(val.biking_walking.value)) {
          this.commute_recommendations_structures[index][key].push(val.biking_walking.value);
          this.commute_recommendations_structures[index].selected_users.push({
            id: val.biking_walking.value,
            name: this[key][val.biking_walking.key].name,
            description: 'Recommending biking or walking',
          });
        } else {
          message.error("You've already added this user");
        }
      }
      if (val.inactive && val.inactive.value) {
        let key = 'inactive_users_with_single_occupant_vehicle_trips';
        if (!selected_users.includes(val.inactive.value)) {
          this.commute_recommendations_structures[index][key].push(val.inactive.value);
          this.commute_recommendations_structures[index].selected_users.push({
            id: val.inactive.value,
            name: this[key][val.inactive.key].name,
            description: 'Recommending transit, biking or walking',
          });
        } else {
          message.error("You've already added this user");
        }
      }
      if (val.email_day && val.email_day.value) {
        let key = 'email_day';
        this.commute_recommendations_structures[index][key] = val.email_day.value;
      }
    },
    setInputStartDate(val, index) {
      this.commute_recommendations_structures[index]['start_date'] = dayjs(
        val.start_date.value,
        'MMM, D, YYYY',
      ).format('YYYY-MM-DD');
    },
    setInputEndDate(val, index) {
      this.commute_recommendations_structures[index]['end_date'] = dayjs(
        val.end_date.value,
        'MMM, D, YYYY',
      ).format('YYYY-MM-DD');
    },
    addWeeklyCredit() {
      // console.log(this.commute_recommendations_structures.length);
      const length = this.commute_recommendations_structures;
      if (length >= 3) return;
      // console.log('after if ! ');
      let newArray = [];
      this.commute_recommendations_structures.map((item) => {
        newArray.push(item);
      });
      newArray.push(this.default_commute_recommendations_DTO);
      this.commute_recommendations_structures = newArray;
      // console.log(' this.commute_recommendations_structures', this.commute_recommendations_structures);
    },
    removeWeeklyCredit() {
      let newArray = [];
      this.commute_recommendations_structures.map((item) => {
        newArray.push(item);
      });
      newArray.pop();
      this.commute_recommendations_structures = newArray;
      // this.commute_recommendations_structures.pop();
    },
  },
  watch: {
    rewardData: function (val) {
      if (this.rewardData) {
        // // console.log("this.rewardData.weekly_credits => ", this.rewardData.weekly_credits);
        // validate config to get away from any errors
        const data = this.rewardData.commute_recommendations
          ? JSON.parse(JSON.stringify(this.rewardData.commute_recommendations))
          : this.commute_recommendations_structures;
        this.commute_recommendations_structures =
          data.length > 0 ? data : this.commute_recommendations_structures;
        this.checked = this.rewardData?.commute_recommendations_enabled ?? false;
      }
    },
    checked: function (val) {
      if (!val)
        this.commute_recommendations_structures = [this.default_commute_recommendations_DTO];
    },
  },
};
</script>
<style>
.section {
  /* padding: 20px; */
  border-radius: 12px;
  margin: 20px auto;
  font-family: sans-serif;
}

.section-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
}

.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.chip {
  padding: 8px 14px;
  background-color: #f0f0f0;
  border-radius: 20px;
  font-size: 14px;
  cursor: default;
  border: 1px solid #ccc;
}

.chip .close-btn {
  margin-left: 8px;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: #888;
}

.chip .close-btn:hover {
  color: #f00;
}
</style>
